import { api } from "@/lib/api";

const CHUNK = 8 * 1024 * 1024;

export async function uploadChunked(file, onProgress) {
  const { data: init } = await api.post("/videos/uploads", { filename: file.name, content_type: file.type, size: file.size });
  let offset = 0;
  while (offset < file.size) {
    const { data } = await api.put(`/videos/uploads/${init.upload_id}/chunk`, file.slice(offset, offset + CHUNK), {
      params: { offset }, headers: { "Content-Type": "application/octet-stream" },
    });
    offset = data.received;
    onProgress?.(Math.round((offset / file.size) * 100));
  }
  return (await api.post(`/videos/uploads/${init.upload_id}/complete`)).data;
}
